import PDFPreviewLightbox from '../../../../../js/reports/leavesReport/pdfPreview/PDFPreviewLightbox'

const ApPdfPreviewLightbox = function() {}

ApPdfPreviewLightbox.prototype = _.create(PDFPreviewLightbox.prototype, {
    createPDFLightboxController: function({lightBoxEl, titleEl, popupId, eventNamespace}) {
        return new APReportsPage.PDFPreviewLightboxController().init({
            lightBoxEl: lightBoxEl,
            titleEl: titleEl,
            popupId: popupId,
            eventNamespace: eventNamespace,
            productSettingsValidator: new APProductSettingsValidator(),
            reportRightsValidator: new APReportRightsValidator(),
        })
    }
})

export default ApPdfPreviewLightbox


// WEBPACK FOOTER //
// ./web/actiplans/js/reports/leaveTimeBalancesReportPage/pdfPreview/PDFPreviewLightbox.js